// extracted by mini-css-extract-plugin
module.exports = {"name":"_2u5IT27-R9ZnCKsK5jbtvv","capacity":"_13sER1NBucT8YXpPCjozqk","pricing":"gwx05uoeLaeVl77aaHXer"};